module.exports = __webpack_public_path__ + "static/media/Slide21.f4c7c690.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slides/Slide21.png
// module id = 1643
// module chunks = 0